module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('left-side', {
    attrs: {
      "is-show": _vm.leftshow
    }
  }), _vm._v(" "), _c('div', {
    class: ['container', _vm.rightSide]
  }, [_c('nav-bar', {
    on: {
      "on-left-side": _vm.onLeftSide,
      "on-sort-view": _vm.onSortView
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home-list"
  }, [_c('touch-item'), _vm._v(" "), _c('touch-item'), _vm._v(" "), _c('touch-item'), _vm._v(" "), _c('touch-item'), _vm._v(" "), _c('touch-item'), _vm._v(" "), _c('touch-item'), _vm._v(" "), _c('touch-item')], 1), _vm._v(" "), _c('foot-bar')], 1), _vm._v(" "), _c('sort-bgview', {
    attrs: {
      "sortview": _vm.sortview
    },
    on: {
      "on-change-show": _vm.onChangeShow
    }
  }), _vm._v(" "), _c('share-view', {
    attrs: {
      "is-show": _vm.showshare
    },
    on: {
      "on-share-view": _vm.onShareView
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22fcc943"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
// module id = 48
// module chunks = 0